import type { WorkTranslation } from "./en.work";

const workUz: WorkTranslation = {
  apps: {
    title: "Ilovalar",
    intro: "Har bir ilovaning o'z versiyalari bor. Versiya qo'lda, git tegidan yoki deploydan paydo bo'lishi mumkin.",
    empty: "Hozircha ilovalar yo'q. Versiyalarini kuzatish uchun ilova qo'shing.",
    add: "Ilova qo'shish",
    edit: "Ilovani tahrirlash",
    name: "Nomi",
    required: "Majburiy",
    platformsLabel: "Platformalar",
    platformsRequired: "Kamida bitta platformani tanlang",
    platforms: { android: "Android", ios: "iOS", desktop: "Desktop", web: "Veb", backend: "Backend" },
    source: "Versiyalar qayerdan keladi",
    sources: { manual: "Qo'lda", tag: "Git teglari", deployment: "Deploylar" },
    sourceHints: {
      manual: "Versiyalarni odamlar qo'lda qo'shadi.",
      tag: "Prefiks va versiya raqami bo'lgan teg shu versiyani yaratadi.",
      deployment: "Muhitga birlashtirilgan o'zgarishlarni qo'shadigan deploy versiya yaratadi.",
    },
    sourceHintEdit: "Bu o'zgarish faqat yangi versiyalarga ta'sir qiladi.",
    repo: "Repozitoriy",
    pickRepo: "Repozitoriyni tanlang",
    removedRepoOption: "{{path}} (bu loyihadan olib tashlangan)",
    noRepos: "Bu loyihada hali repozitoriy yo'q, shuning uchun bu manbadan foydalanib bo'lmaydi.",
    openGitlab: "GitLab sozlamalarini ochish",
    tagPrefix: "Teg prefiksi",
    tagPrefixHint: "Masalan, v yoki android/. Teglar faqat versiya raqamidan iborat bo'lsa, bo'sh qoldiring.",
    tagMeansReleased: "Teg versiya chiqarilganini bildiradi",
    tagReleases: "Teg versiyani chiqarilgan deb belgilaydi.",
    tagNotReleases: "Teg versiyani chiqarilgan deb belgilamaydi.",
    tagPattern: "teglar {{prefix}}*",
    environment: "Production muhiti",
    environmentHint: "Loyiha repozitoriylarida ko'ringan muhitni tanlang yoki nomini yozing. Nomi aynan mos kelishi kerak.",
    sharedPrefix: "Bu repozitoriy va teg prefiksi {{apps}} bilan umumiy, shuning uchun ular bir xil tarkibni oladi.",
    sharedEnvironment: "Bu repozitoriy va muhit {{apps}} bilan umumiy, shuning uchun ular bir xil tarkibni oladi.",
    versionCount_one: "{{count}} ta versiya",
    versionCount_few: "{{count}} ta versiya",
    versionCount_many: "{{count}} ta versiya",
    versionCount_other: "{{count}} ta versiya",
    needsSorting: "Saralash kerak",
    needsSortingHint: "Yangilanishda bu versiyalar qaysi ilovaga tegishli ekani aniqlanmadi. Ularni tekshiring, keyin ilovani saralangan deb belgilang.",
    markSorted: "Saralangan deb belgilash",
    noPlatforms: "Bu ilovaning platformalarini tanlang. Yangilanishda ular aniqlanmadi.",
    repoRemoved: "Bu repozitoriy loyihadan olib tashlangan, shuning uchun ilova undan hech narsa olmaydi. Repozitoriyni qayta qo'shing yoki boshqasini tanlang.",
    archived: "Arxivda",
    archive: "Arxivlash",
    unarchive: "Arxivdan chiqarish",
    archiveTitle: "{{name}} arxivlansinmi?",
    archiveBody: "Ilova GitLabni kuzatishni to'xtatadi va tanlash ro'yxatlaridan chiqadi. Versiyalari qoladi, ulardagi xatolar haqida xabar berish mumkin.",
    archivedToast: "Ilova arxivlandi",
    unarchived: "Ilova arxivdan chiqarildi",
    deleteTitle: "{{name}} o'chirilsinmi?",
    deleteBody: "Unda versiyalar va xato ko'rinishlari yo'q, shuning uchun boshqa hech narsa yo'qolmaydi.",
    merge: "Boshqa ilova bilan birlashtirish",
    mergeTitle: "{{name}} boshqa ilova bilan birlashtirilsinmi?",
    mergeBody: "Tanlangan ilova uning barcha versiyalari, xato ko'rinishlari, regressiya belgilari, test holatlari va navbatdagi GitLab ishlarini hamda platformalarini oladi. Bir xil nomli versiyalar bittaga aylanadi. {{name}} yo'qoladi va buni qaytarib bo'lmaydi.",
    mergeInto: "Qaysi ilova bilan",
    mergeConfirm: "Ilovalarni birlashtirish",
    merged: "Ilovalar birlashtirildi",
    deleted: "Ilova o'chirildi",
    created: "Ilova qo'shildi",
    saved: "Ilova saqlandi",
    ignoredTags_one: "{{count}} ta e'tiborsiz qoldirilgan teg",
    ignoredTags_few: "{{count}} ta e'tiborsiz qoldirilgan teg",
    ignoredTags_many: "{{count}} ta e'tiborsiz qoldirilgan teg",
    ignoredTags_other: "{{count}} ta e'tiborsiz qoldirilgan teg",
    ignoredReason: {
      empty: "prefiksdan keyin versiya yo'q",
      not_semver: "SemVer versiyasi emas, masalan 2.4.0 yoki 2.4.0-rc.1",
      too_long: "versiya 80 belgidan uzun",
    },
  },
  gitlab: {
    chip: {
      failed_pipeline: "Pipeline xato bilan tugadi",
      failed_pipelineMany: "Pipeline xato bilan tugadi · {{count}} ta MR",
      changed_since_tested: "Testdan keyin o‘zgargan",
      changed_since_testedMany: "Testdan keyin o‘zgargan · {{count}} ta MR",
      running_pipeline: "Pipeline ishlamoqda",
      running_pipelineMany: "Pipeline ishlamoqda · {{count}} ta MR",
      draft: "Qoralama MR",
      draftMany: "Qoralama · {{count}} ta MR",
      open: "MR ochiq",
      openMany: "Ochiq · {{count}} ta MR",
      merged: "MR birlashtirildi",
      mergedMany: "Birlashtirildi · {{count}} ta MR",
      deployed: "Joylandi",
      deployedMany: "Joylandi · {{count}} ta MR",
      branch_only: "Branch",
      branch_onlyMany: "{{count}} ta branch",
    },
    chipHint: {
      failed_pipeline: "Bog‘langan merge request’da pipeline xato bilan tugadi.",
      changed_since_tested: "Oxirgi yakunlangan raunddan keyin yangi commit’lar qo‘shildi. Raund natijalari va vazifa holati o‘zgarmaydi.",
      running_pipeline: "Bog‘langan merge request’da pipeline ishlamoqda.",
      draft: "Bog‘langan merge request hali qoralama.",
      open: "Bog‘langan merge request ochiq.",
      merged: "Bog‘langan merge request birlashtirildi, lekin hali joylanmagan.",
      deployed: "Bog‘langan o‘zgarish birlashtirildi va joylandi.",
      branch_only: "Branch bog‘langan, merge request hali yo‘q.",
      mrs: "Merge request’lar: {{count}}.",
      branches: "Branch’lar: {{count}}.",
      moreBranches: "Boshqa branch’lar: {{count}}.",
      environments: "Muhitlar: {{environments}}.",
      disconnected: "GitLab uzilgan, shuning uchun bu ma’lumot eskirgan bo‘lishi mumkin.",
    },
    pipeline: {
      created: "Pipeline yaratildi",
      waiting_for_resource: "Pipeline kutmoqda",
      preparing: "Pipeline tayyorlanmoqda",
      pending: "Pipeline navbatda",
      running: "Pipeline ishlamoqda",
      success: "Pipeline o‘tdi",
      failed: "Pipeline xato bilan tugadi",
      canceling: "Pipeline bekor qilinmoqda",
      canceled: "Pipeline bekor qilindi",
      skipped: "Pipeline o‘tkazib yuborildi",
      manual: "Pipeline qo‘lda bajariladigan qadamni kutmoqda",
      scheduled: "Pipeline rejalashtirildi",
      lastKnown: "Oxirgi ma’lum holat: {{status}}",
    },
    mrState: { opened: "Ochiq", merged: "Birlashtirildi", closed: "Yopilgan", locked: "Qulflangan" },
    draft: "Qoralama",
    source: {
      branch: "Branch nomidan topildi",
      title: "MR sarlavhasidan topildi",
      description: "MR tavsifidan topildi",
      manual: "Qo‘lda qo‘shilgan",
    },
    mergeRequests: "Merge request’lar",
    branches: "Branch’lar",
    environments: "Muhitlar",
    disconnected: "GitLab uzilgan. Bu yerda Mixla oxirgi marta ko‘rgan ma’lumotlar ({{time}}). Platforma menejeri qayta ulamaguncha havola qo‘shib bo‘lmaydi.",
    disconnectedNever: "GitLab uzilgan. Platforma menejeri qayta ulamaguncha havola qo‘shib bo‘lmaydi.",
    changedNotice: "Oxirgi yakunlangan raunddan keyin yangi commit’lar qo‘shildi. Raund natijalari va vazifa holati o‘zgarmaydi, qayta sinovni siz yoki yoqilgan qoida so‘raydi.",
    waiting: "{{status}} holatiga o‘tish kutilmoqda: {{blockers}}",
    blockerEnvironment: "{{mr}} hali {{environment}} muhitida emas",
    blockerMerge: "{{mr}} hali birlashtirilmagan",
    emptyTitle: "Hali kod bog‘lanmagan",
    emptyBody: "Shu nomli branch yuklang yoki merge request sarlavhasiga vazifa kalitini yozing, shunda u o‘zi bog‘lanadi. Avvalgi ishlar GitLab ular bo‘yicha yangi faollik haqida xabar berganda ko‘rinadi.",
    copyBranch: "Branch nomini nusxalash",
    branchForNewWork: "Yangi ish uchun branch nomi",
    addLink: "Merge request yoki branch’ni bog‘lash",
    addLinkPlaceholder: "GitLab havolasini qo‘ying",
    addLinkButton: "Havola qo‘shish",
    addLinkHint: "U shu loyihaga ulangan repozitoriydan bo‘lishi kerak.",
    linkAdded: "Havola qo‘shildi",
    lastSynced: "Oxirgi sinxronlash: {{time}}",
    bugEmptyTitle: "Hali kod bog‘lanmagan",
    bugEmptyBody: "Shu nomli branch yuboring yoki xato kalitini merge request sarlavhasiga yozing, u o‘zi bog‘lanadi.",
    bugUnconfirmed: "Faqat tavsifda tilga olingan. Kimdir tasdiqlamaguncha tuzatish chiqarilgani hisoblanmaydi va xatoni tuzatilgan deb belgilashga ta’sir qilmaydi.",
    unconfirmed: "Faqat tavsifda tilga olingan. Kimdir tasdiqlamaguncha qoidalar, raund izohlari va kartochkada hisobga olinmaydi.",
    confirmLink: "Bog‘lanishni tasdiqlash",
    linkConfirmed: "Bog‘lanish tasdiqlandi",
    removeLink: "Bog‘lanishni olib tashlash",
    removeTitle: "{{name}} bilan bog‘lanish olib tashlansinmi?",
    removeBody: "GitLab yangi faollik haqida xabar berganda ham u qaytmaydi. Uni qo‘lda qayta qo‘shish mumkin.",
    linkRemoved: "Bog‘lanish olib tashlandi",
  },
  testStageDetail: {
    round: "{{n}}-raund",
    failed_one: "{{count}} ta xato",
    failed_few: "{{count}} ta xato",
    failed: "{{count}} ta xato",
  },
  doneGuard: {
    title: "Tekshirilmagan ishni «Tayyor»ga o‘tkazasizmi?",
    one: "{{key}} testdan o‘tmagan. U «tekshirilmagan» deb belgilanadi.",
    many_one: "{{keys}} testdan o‘tmagan ({{total}} tadan {{count}} tasi). U «tekshirilmagan» deb belgilanadi.",
    many_few: "{{keys}} testdan o‘tmagan ({{total}} tadan {{count}} tasi). Ular «tekshirilmagan» deb belgilanadi.",
    many: "{{keys}} testdan o‘tmagan ({{total}} tadan {{count}} tasi). Ular «tekshirilmagan» deb belgilanadi.",
    confirm: "«Tayyor»ga o‘tkazish",
  },
  testStage: {
    not_started: "Sinalmagan",
    ready_for_test: "Sinovga tayyor",
    in_testing: "Sinovda",
    changes_requested: "Tuzatish kerak",
    ready_for_retest: "Qayta sinovga tayyor",
    passed: "O‘tdi",
  },
  poker: {
    nav: "Rejalash pokeri",
    title: "Rejalash pokeri",
    start: "Rejalash pokeri",
    banner: "Rejalash pokeri ketmoqda — {{name}} boshqaradi ({{done}} / {{total}} tayyor)",
    join: "Qo‘shilish",
    noneTitle: "Rejalash pokeri ketmayapti",
    noneBody: "Uni Beklog sahifasidagi sprintdan boshlang: jamoa sprintning baholanmagan vazifalarini birga baholaydi.",
    present_one: "{{count}} kishi",
    present_few: "{{count}} kishi",
    present: "{{count}} kishi",
    facilitator: "Boshqaruvchi: {{name}}",
    takeOver: "Boshqaruvni olish",
    end: "Sessiyani tugatish",
    round: "{{n}}-raund",
    yourVote: "Sizning ovozingiz",
    changeUntilReveal: "Ovozlar ochilguncha uni o‘zgartirish mumkin.",
    spread: "Tarqoqlik {{spread}}",
    nVotes_one: "{{count}} ta ovoz",
    nVotes_few: "{{count}} ta ovoz",
    nVotes: "{{count}} ta ovoz",
    noVotes: "ovozlar yo‘q",
    agree: "Kelishilgan baho:",
    reveal: "Ovozlarni ochish",
    revote: "Qayta ovoz berish",
    skip: "O‘tkazib yuborish",
    skipped: "o‘tkazildi",
    allDone: "Har bir vazifa bo‘yicha qaror bor",
    allDoneBody: "Navbatdan o‘tkazilganini tanlang yoki sessiyani tugating.",
    votes: "Ovozlar · {{total}} tadan {{voted}}",
    votedLabel: "{{name}} ovoz berdi",
    notVotedLabel: "{{name}} hali ovoz bermadi",
    queue: "Vazifalar · {{done}} / {{total}}",
    saidRevealed: "Ovozlar ochildi",
    saidVoted: "{{total}} tadan {{n}} tasi ovoz berdi",
    saidFacilitator: "Endi {{name}} boshqaradi",
  },
  templates: {
    saveAs: "Shablon sifatida saqlash",
    saveAsHint: "Nomi, tavsifi, muhimligi, teglari, bahosi, cheklistlari (belgisiz) va kichik vazifalar nomlari.",
    saved: "Shablon saqlandi",
    name: "Shablon nomi",
    taskTitle: "Vazifa nomi",
    fromTemplate: "Shablon",
    blank: "Bo‘sh vazifa",
    fromNamed: "“{{name}}” dan",
    titleHint: "“{{title}}” ni olish uchun bo‘sh qoldiring.",
    checklistFromTemplate: "Shablondan cheklist",
    taskTemplates: "Vazifa shablonlari",
    taskTemplatesIntro: "Qayta-qayta yaratiladigan vazifalar: nomi, tavsifi, muhimligi, bahosi, cheklistlari va kichik vazifalari. “Yangi vazifa” da tanlanadi.",
    new: "Yangi shablon",
    edit: "Shablonni tahrirlash",
    none: "Hali shablonlar yo‘q. Shu yerda yoki istalgan vazifaning ··· menyusidan yarating.",
    nChecklists_one: "{{count}} ta cheklist",
    nChecklists_few: "{{count}} ta cheklist",
    nChecklists: "{{count}} ta cheklist",
    nSubtasks_one: "{{count}} ta kichik vazifa",
    nSubtasks_few: "{{count}} ta kichik vazifa",
    nSubtasks: "{{count}} ta kichik vazifa",
    checklists: "Cheklistlar",
    checklistsHint: "Har blokda bitta cheklist: birinchi qatorda nomi, pastda bandlari. Cheklistlarni bo‘sh qator bilan ajrating.",
    subtasks: "Kichik vazifalar",
    subtasksHint: "Har qatorda bitta kichik vazifa nomi.",
    deleteTitle: "“{{name}}” shabloni o‘chirilsinmi?",
    deleteBody: "Undan yaratilgan vazifalar qoladi. Uni ishlatgan takrorlar ham o‘chiriladi.",
    checklistTemplates: "Cheklist shablonlari",
    checklistTemplatesIntro: "Istalgan vazifaga bir bosishda qo‘shiladigan cheklistlar.",
    newChecklist: "Yangi cheklist shabloni",
    editChecklist: "Cheklist shablonini tahrirlash",
    noneChecklists: "Hali cheklist shablonlari yo‘q.",
    items: "Bandlar",
    itemsHint: "Har qatorda bitta band.",
    nItems_one: "{{count}} ta band",
    nItems_few: "{{count}} ta band",
    nItems: "{{count}} ta band",
    recurring: "Takrorlanuvchi vazifalar",
    recurringIntro: "Jadval bo‘yicha vazifaga aylanadigan shablon, loyiha vaqt mintaqasida. Faol sprintga qo‘yilgan takroriy vazifalar sprint hajmiga kirmaydi.",
    newRule: "Yangi takrorlanuvchi vazifa",
    editRule: "Takrorlanuvchi vazifani tahrirlash",
    needTemplate: "Avval vazifa shablonini yarating.",
    noRules: "Hali takrorlanuvchi vazifalar yo‘q.",
    template: "Shablon",
    repeat: "Takror",
    on: "Kuni",
    onDays: "Shu kunlarda",
    dayOfMonth: "Oyning kuni",
    hour: "Soat",
    atHour: "soat {{hour}}:00 da",
    intoSprint: "faol sprintga",
    intoSprintLabel: "Faol sprintga qo‘yish (faoli bo‘lmasa — bekloga)",
    skipIfOpen: "Oxirgi yaratilgani ochiq tursa, o‘tkazib yuborish",
    ruleHint: "Vaqt loyiha vaqt mintaqasida (sprint sozlamalari).",
    pause: "To‘xtatish",
    resume: "Davom ettirish",
    paused: "To‘xtatilgan",
    pausedBecause: "To‘xtatilgan: {{reason}}",
    nextRun: "Keyingisi: {{when}}",
    lastTask: "oxirgisi {{key}}",
    rule: {
      daily: "Har kuni",
      dailyOn: "Har {{days}}",
      weekly: "Har hafta: {{day}}",
      monthly: "Har oyning {{day}}-kuni",
      kindDaily: "Har kuni",
      kindWeekly: "Har hafta",
      kindMonthly: "Har oy",
    },
  },
  flow: {
    nav: "Oqim",
    title: "Oqim",
    period: "Davr",
    lastDays: "Oxirgi {{n}} kun",
    days: "{{n}} kun",
    historySince: "Holatlar tarixi {{date}} dan yozilmoqda; undan oldingi ish o‘lchanmaydi.",
    notEnough: "Sikl vaqti o‘lchangan tayyor vazifalar hozircha {{n}} ta: foizlar va “qotib qolgan” belgisi {{min}} tadan ko‘rinadi.",
    cycleMedian: "Sikl vaqti (mediana)",
    p85: "85% — {{v}} gacha",
    leadMedian: "Bajarilish vaqti (mediana)",
    throughput: "O‘tkazuvchanlik",
    perWeek: "{{n}} / hafta",
    completed_one: "{{count}} ta tayyor",
    completed_few: "{{count}} ta tayyor",
    completed: "{{count}} ta tayyor",
    wip: "Hozir jarayonda",
    wipHint: "Faol holatdagi vazifalar",
    cfd: "Jamlanma oqim",
    cfdHint: "Har kun oxirida holat guruhlari bo‘yicha vazifalar. Kengayib borayotgan o‘rta qism ish jarayonda to‘planayotganini bildiradi.",
    cat: { not_started: "Boshlanmagan", active: "Jarayonda", done: "Tayyor" },
    aging: "Qotib qolgan ishlar",
    agingHint: "Ochiq vazifalar joriy holatdagi vaqti bo‘yicha. {{v}} dan uzoqlari belgilangan (tayyor ishning 85% i tezroq bitgan).",
    agingHintNoData: "Ochiq vazifalar joriy holatdagi vaqti bo‘yicha.",
    overP85: "odatdagidan uzoq",
    noAging: "Jarayonda hech narsa yo‘q.",
  },
  standup: {
    nav: "Stendap",
    title: "Stendap",
    since: "{{date}} dan beri",
    range: "Davr",
    sinceLastDay: "Oxirgi ish kunidan beri",
    lastWeek: "Oxirgi 7 kun",
    scope: "Vazifalar",
    auto: "Faol sprint (yoki hammasi)",
    sprintScope: "{{name}}",
    allTasks: "Loyihaning barcha vazifalari",
    blocked_one: "{{count}} ta vazifa bloklangan",
    blocked_few: "{{count}} ta vazifa bloklangan",
    blocked: "{{count}} ta vazifa bloklangan",
    blockedBy: "{{keys}} ni kutmoqda",
    finished: "Tayyor",
    moved: "Ko‘chirildi",
    tested: "Sinaldi",
    round: "{{n}}-raund: {{passed}} o‘tdi, {{failed}} yiqildi",
    now: "Hozir",
    emptyTitle: "Hozircha bo‘sh",
    emptyBody: "Bu yerda ko‘chirishlar, izohlar, test raundlari va jarayondagi ishlar chiqadi.",
  },
  epics: {
    nav: "Epiklar",
    title: "Epiklar",
    epic: "Epik",
    new: "Yangi epik",
    edit: "Epikni tahrirlash",
    name: "Nomi",
    description: "Tavsif",
    color: "Rang",
    targetDate: "Maqsad sanasi",
    target: "Maqsad: {{date}}",
    stateLabel: "Epik holati",
    state: { planned: "Rejalangan", in_progress: "Jarayonda", done: "Tayyor" },
    noEpic: "Epiksiz",
    none: "Hali epiklar yo‘q",
    change: "Epikni o‘zgartirish",
    followsParent: "Kichik vazifa ota vazifasining epikida",
    noTasks: "Hali vazifalar yo‘q",
    progressTasks: "{{done}} / {{total}} vazifa",
    progressPts: "{{done}} / {{total}} ball",
    doneEpics: "Tayyorlari",
    emptyTitle: "Hali epiklar yo‘q",
    emptyBody: "Epik turli sprintlardagi vazifalarni birlashtiradi va jarayonni ko‘rsatadi. Vazifa epikni sprint kabi tanlaydi.",
    deleteTitle: "“{{name}}” epiki o‘chirilsinmi?",
    deleteBody: "Uning vazifalari epiksiz qoladi.",
    filter: "Epik",
    nEpics_one: "{{count}} ta epik",
    nEpics_few: "{{count}} ta epik",
    nEpics: "{{count}} ta epik",
  },
  releases: {
    nav: "Relizlar",
    title: "Relizlar",
    release: "Reliz",
    new: "Yangi reliz",
    name: "Nomi",
    nameHint: "SemVer, masalan 2.4.0 yoki 2.4.0-rc.1. +build qismi tashlab yuboriladi.",
    targetDate: "Maqsad sanasi",
    state: { unreleased: "Chiqarilmagan", released: "Chiqarilgan", archived: "Arxivda" },
    noRelease: "Relizsiz",
    change: "Relizni o‘zgartirish",
    releasedOn: "{{date}} da chiqarilgan",
    targetOn: "Maqsad: {{date}}",
    noItems: "Hali bo‘sh",
    itemsHint: "Bu relizni vazifalarda (yoki ommaviy) va tuzatilgan baglarda tanlang.",
    items: "Vazifalar {{tasks}} · baglar {{bugs}}",
    progressLabel: "{{total}} tadan {{done}} tasi tayyor va tekshirilgan",
    nDone_one: "{{count}} ta tayyor",
    nDone_few: "{{count}} ta tayyor",
    nDone: "{{count}} ta tayyor",
    nNotVerified_one: "{{count}} ta tayyor, tekshirilmagan",
    nNotVerified_few: "{{count}} ta tayyor, tekshirilmagan",
    nNotVerified: "{{count}} ta tayyor, tekshirilmagan",
    nOpen_one: "{{count}} ta ochiq",
    nOpen_few: "{{count}} ta ochiq",
    nOpen: "{{count}} ta ochiq",
    nBugsFixed: "Tuzatilgan baglar: {{fixed}} / {{total}}",
    notes: "Reliz qaydlari",
    notesGenerated: "vazifalardan yig‘ilgan",
    notesEdited: "tahrirlangan",
    notesFrozen: "chiqarilganda qotirilgan",
    notesEmpty: "Vazifalar tayyor, baglar tuzatilgani sari qaydlar to‘ladi.",
    editNotes: "Qaydlarni tahrirlash",
    regenerate: "Qayta yig‘ish",
    copyMarkdown: "Markdown sifatida nusxalash",
    copied: "Reliz qaydlari nusxalandi",
    markReleased: "Chiqarilgan deb belgilash",
    markTitle: "{{name}} chiqarilsinmi?",
    freezeNote: "Reliz qaydlari hozirgi holatida qotiriladi.",
    openItems_one: "{{count}} ta element hali ochiq.",
    openItems_few: "{{count}} ta element hali ochiq.",
    openItems: "{{count}} ta element hali ochiq.",
    moveTo: "Ochiqlarini ko‘chirish:",
    moveToNew: "Yangi relizga ko‘chirish",
    releaseAnyway: "Baribir chiqarish (ular qoladi, kirmagan deb ko‘rsatiladi)",
    released: "{{name}} chiqarildi",
    archive: "Arxivlash",
    unarchive: "Arxivdan chiqarish",
    deleteTitle: "“{{name}}” relizi o‘chirilsinmi?",
    deleteBody: "Uning vazifalari va baglari usiz qoladi. Agar unda ko‘rinishlar, tuzatish yoki test raundlari bo‘lsa, arxivlanadi.",
    filter: "Reliz",
    fixRelease: "Tuzatish versiyasi",
    app: "Ilova",
    allApps: "Barcha ilovalar",
    chooseApp: "Ilovani tanlang",
    showMore: "Yana ko‘rsatish",
    noAppsTitle: "Hali ilovalar yo‘q",
    noAppsBody: "Har bir versiya Android yoki Backend kabi ilovaga tegishli. Boshlash uchun bittasini qo‘shing.",
    noAppsAsk: "Har bir versiya Android yoki Backend kabi ilovaga tegishli. Uni loyiha menejeri qo‘sha oladi.",
    appEmpty: {
      manual: "Hali versiyalar yo‘q.",
      tag: "Hali versiyalar yo‘q. Mos teg yuklanganda paydo bo‘ladi.",
      deployment: "Hali versiyalar yo‘q. Production deploy qo‘shilgan o‘zgarishlarni olib kelganda paydo bo‘ladi.",
    },
    nameError: {
      empty: "Versiyaga nom bering.",
      not_semver: "Bu SemVer versiyasi emas. 2.4.0 yoki 2.4.0-rc.1 ko‘rinishida, boshida v siz yozing.",
      too_long: "Nom 80 belgidan uzun.",
    },
    olderHint: "{{app}} versiyalari deploylardan olinadi, shuning uchun bu yerda qo‘shilgani allaqachon chiqqan eski versiya hisoblanadi.",
    olderManagerOnly: "{{app}} versiyalari deploylardan olinadi. Eski versiyani qo‘lda faqat menejer qo‘sha oladi.",
    cameOut: "Chiqqan sanasi",
    cameOutMissing: "Chiqqan sanani tanlang.",
    editTarget: "Maqsad sanasini belgilash",
    marker: {
      rolled_back: "Orqaga qaytarilgan",
      incomplete: "Tarkibi to‘liq bo‘lmasligi mumkin",
      needs_merge: "Nomi boshqa versiya bilan bir xil",
      notes_frozen: "Qaydlar qotirilgan",
    },
    rolledBackShort: "orqaga qaytarilgan",
    rolledBackHint: "{{date}} da orqaga qaytarilgan. Bu commit yoki uni o‘z ichiga olgani qayta deploy qilinmaguncha tuzatishlari hisobga olinmaydi.",
    incompleteHint: "Bu versiyadagi ayrim commitlar hali merge request bilan bog‘lanmagan, shuning uchun ba’zi elementlar yetishmasligi mumkin.",
    incompleteNote: "Ba’zi elementlar yetishmasligi mumkin: {{note}}",
    needsMergeHint: "Yangilanishda bu ilovada shu nomli boshqa versiya topildi. Menejer ularni birlashtira oladi.",
    notesFrozenHint: "Keyin aniqlangan elementlar qaydlarga emas, tarkibga tushadi.",
    fromTag: "{{tag}} tegidan",
    fromDeployment: "Deploydan",
    group: {
      shipped: "Chiqqan",
      planned_not_shipped: "Rejalashtirilgan, lekin chiqmagan",
      unplanned: "Rejasiz chiqqan",
    },
    groupEmpty: {
      shipped: "Hali hech narsa chiqmagan.",
      planned_not_shipped: "Kutayotgani yo‘q: rejalashtirilganlarning hammasi chiqdi.",
      unplanned: "Rejasiz chiqqan narsa yo‘q.",
    },
    listCapped: "{{total}} ta vazifadan dastlabki {{listed}} tasi ko‘rsatilgan.",
    pickSearch: "Versiyalarni qidirish",
    noVersions: "Hali versiyalar yo‘q",
    noMatch: "Mos versiyalar yo‘q",
    otherSelected: "Tanlangan boshqa versiya",
    lock: {
      manager_only: "Allaqachon chiqqan: faqat menejer o‘zgartira oladi",
      archived: "Arxivda, o‘zgartirib bo‘lmaydi",
    },
    rename: "Nomini o‘zgartirish",
    renameTitle: "{{name}} nomini o‘zgartirish",
    move: "Boshqa ilovaga ko‘chirish",
    moveTitle: "{{name}} ni ko‘chirish",
    moveHint: "Tarkibi, ko‘rinishlari va bayroqlari u bilan birga o‘tadi.",
    moveNoApps: "Bu loyihada boshqa faol ilova yo‘q.",
    moved: "{{name}} {{app}} ga ko‘chirildi",
    merge: "Boshqa versiyaga birlashtirish",
    mergeTitle: "{{name}} ni birlashtirish",
    mergePick: "Qoladigan versiyani tanlang.",
    mergeConfirmTitle: "Bu versiyalar birlashtirilsinmi?",
    mergeConfirm: "{{name}} ga birlashtirish",
    mergeBody: "{{from}} dagi hamma narsa {{to}} ga o‘tadi, uning nomi va qaydlari saqlanadi. {{from}} havolalari {{to}} ni ochadi. Buni bekor qilib bo‘lmaydi.",
    merged: "{{name}} ga birlashtirildi",
    collisionTitle: "{{app}} da {{name}} allaqachon bor",
    collisionBody: "Versiyani shu nomli versiyasi bor ilovaga ko‘chirib bo‘lmaydi. O‘rniga ularni birlashtirish mumkin.",
    nItems_one: "{{count}} ta element",
    nItems_few: "{{count}} ta element",
    nItems_many: "{{count}} ta element",
    nItems_other: "{{count}} ta element",
    nSightings_one: "{{count}} ta ko‘rinish",
    nSightings_few: "{{count}} ta ko‘rinish",
    nSightings_many: "{{count}} ta ko‘rinish",
    nSightings_other: "{{count}} ta ko‘rinish",
    deletedArchived: "{{name}} da ko‘rinishlar, tuzatish yoki test raundlari bor, shuning uchun arxivlandi",
  },
  views: {
    views: "Ko‘rinishlar",
    mine: "Mening ko‘rinishlarim",
    shared: "Loyiha bilan ulashilgan",
    none: "Saqlangan ko‘rinishlar hali yo‘q",
    saveAs: "Ko‘rinish sifatida saqlash…",
    update: "“{{name}}” ni yangilash",
    updated: "Ko‘rinish yangilandi",
    rename: "Nomini o‘zgartirish",
    share: "Loyiha bilan ulashish",
    unshare: "Shaxsiy qilish",
    delete: "Ko‘rinishni o‘chirish",
    leave: "Ko‘rinishni yopish",
    moveUp: "Yuqoriga",
    moveDown: "Pastga",
    unsaved: "Saqlanmagan o‘zgarishlar bor",
    name: "Nomi",
    shareWithProject: "Loyihadagi hammaga ulashish",
    hint: "Ko‘rinish filtrlar, ko‘rinish turi, guruhlash va saralashni eslab qoladi.",
    deleteTitle: "“{{name}}” ko‘rinishi o‘chirilsinmi?",
    deleteBody: "Vazifalar o‘zgarmaydi.",
    deleteSharedBody: "U loyihadagi hamma uchun yo‘qoladi. Vazifalar o‘zgarmaydi.",
    staleFilters: "Bu ko‘rinishdagi ba’zi filtrlar endi mavjud emas va tashlab ketildi.",
  },
  shortcuts: {
    assignedToYou: "Sizga biriktirildi",
    title: "Tezkor tugmalar",
    status: "Holatni o‘zgartirish",
    assignees: "Ijrochilarni o‘zgartirish",
    assignMe: "O‘zimga biriktirish",
    priority: "Muhimlikni o‘zgartirish",
    estimate: "Bahoni o‘zgartirish",
    due: "Muddatni o‘zgartirish",
    tags: "Teg qo‘shish yoki olib tashlash",
    sprint: "Sprintga ko‘chirish",
    comment: "Izoh yozish",
    nextPrev: "Ro‘yxatdagi keyingi / oldingi vazifa",
    close: "Yopish",
    help: "Shu ro‘yxatni ko‘rsatish",
    enabled: "Bir harfli tugmalar",
    enabledHint: "Ekran o‘quvchi yoki ovozli boshqaruvga xalaqit bersa, o‘chiring. J, K va Esc ishlashda davom etadi.",
  },
  bulk: {
    bar: "Tanlangan vazifalar",
    nSelected: "{{count}} ta tanlandi",
    working: "Qo‘llanmoqda…",
    clear: "Tanlovni bekor qilish",
    add: "Qo‘shish",
    remove: "Olib tashlash",
    only: "Faqat",
    updated_one: "{{count}} ta vazifa yangilandi",
    updated_few: "{{count}} ta vazifa yangilandi",
    updated: "{{count}} ta vazifa yangilandi",
    failed: "Hech narsa o‘zgarmadi. {{message}}",
    deleteTitle_one: "{{count}} ta vazifa o‘chirilsinmi?",
    deleteTitle_few: "{{count}} ta vazifa o‘chirilsinmi?",
    deleteTitle: "{{count}} ta vazifa o‘chirilsinmi?",
    deleteBody: "Ularning kichik vazifalari ham o‘chiriladi. Buni qaytarib bo‘lmaydi.",
    oneProjectOnly: "Holat, ijrochilar va sprint faqat bitta loyiha vazifalari uchun",
    select: "{{key}} ni tanlash",
    selectAll: "Ko‘rsatilganlarning hammasini tanlash",
    failedRow: "O‘zgarmadi",
  },
  work: {
    fieldFilter: "Maydon",
    chooseField: "Maydonni tanlang",
    clearFieldFilter: "Maydon filtrini tozalash",
    fieldContains: "O‘z ichiga oladi…",
    fieldCompare: "Taqqoslash",
    after: "Keyin",
    before: "Oldin",
    fieldIsSet: "To‘ldirilgan",
    fieldIsEmpty: "Bo‘sh",
    yes: "Ha",
    no: "Yo‘q",
    properties: "Xususiyatlar",
    createdBy: "{{name}} yaratgan · {{date}}",
    descriptionHint: "@ — eslatish. Maydondan chiqqaningizda saqlanadi · Esc — bekor qilish · ⌘/Ctrl+Enter — darhol saqlash.",
    editDescription: "Tavsifni tahrirlash",
    saving: "Saqlanmoqda…",
    saved: "Saqlandi",
    subtask: "Kichik vazifa",
    checklist: "Nazorat ro‘yxati",
    link: "Bog‘lanish",
    file: "Fayl",
    prevTask: "Oldingi vazifa",
    nextTask: "Keyingi vazifa",
    nOfTotal: "{{n}} / {{total}}",
    openPage: "Sahifa sifatida ochish",
    myWork: "Mening vazifalarim",
    myWorkIntro: "Barcha loyihalarda sizga biriktirilgan ochiq vazifalar.",
    allTasks: "Barcha vazifalar",
    allTasksIntro: "Siz ocha oladigan barcha loyihalardagi vazifalar.",
    newTaskShortcut: "Yangi vazifa (C)",
    search: "Kalit yoki nom bo‘yicha qidirish",
    view: "Ko‘rinish",
    views: { list: "Ro‘yxat", board: "Doska", table: "Jadval", calendar: "Kalendar" },
    status: "Holat",
    nStatuses: "Holatlar: {{count}}",
    assignees: "Ijrochilar",
    nPeople: "{{count}} kishi",
    assignedToMe: "Menga biriktirilgan",
    mine: "Meniki",
    tags: "Teglar",
    nTags: "Teglar: {{count}}",
    project: "Loyiha",
    due: "Muddat",
    anyDue: "Istalgan muddat",
    dueThisWeek: "Bir hafta ichida",
    dueAt: "Muddat sanasi va vaqti",
    groupBy: "Guruhlash",
    group: { status: "Holat bo‘yicha", assignee: "Ijrochi bo‘yicha", due: "Muddat bo‘yicha", priority: "Muhimlik bo‘yicha", project: "Loyiha bo‘yicha", none: "Guruhlashsiz" },
    sort: "Saralash",
    sorts: { manual: "Qo‘lda tartib", due: "Muddat", priority: "Muhimlik", created: "Yangilari", updated: "Yaqinda o‘zgargan", title: "Nomi", key: "Kalit" },
    showClosed: "Yopilganlar",
    showSubtasks: "Kichik vazifalar",
    clearFilters: "Filtrlarni tozalash",
    emptyTitle: "Hozircha vazifa yo‘q",
    emptyBody: "Birinchi vazifani yarating. Claude CLI orqali yuborgan vazifalar ham shu yerda chiqadi.",
    emptyAll: "Hozircha bo‘sh.",
    noMatch: "Mos vazifa yo‘q.",
    noTasksHere: "Vazifa yo‘q",
    capped: "Dastlabki 500 ta vazifa ko‘rsatilmoqda. Qolganini ko‘rish uchun filtrlarni toraytiring.",
    addTask: "Vazifa qo‘shish",
    addTaskTo: "«{{status}}» ga vazifa qo‘shish",
    addTaskOn: "{{date}} muddatli vazifa qo‘shish",
    unassigned: "Biriktirilmagan",
    noValue: "Qiymatsiz",
    nobody: "Hech kim",
    category: { not_started: "Bajarilishi kerak", active: "Jarayonda", done: "Bajarildi", closed: "Yopilgan" },
    priority: "Muhimlik",
    priorities: { urgent: "Shoshilinch", high: "Yuqori", medium: "O‘rta", low: "Past", none: "Muhimliksiz" },
    priorityIs: "Muhimlik: {{priority}}",
    changePriority: "Muhimlik: {{priority}}. O‘zgartirish",
    nPriorities: "Muhimlik: {{count}}",
    dueBucket: { overdue: "Muddati o‘tgan", today: "Bugun", tomorrow: "Ertaga", week: "Shu hafta", later: "Keyinroq", none: "Muddatsiz" },
    today: "Bugun",
    tomorrow: "Ertaga",
    yesterday: "Kecha",
    inAWeek: "Bir haftadan keyin",
    clearDue: "Muddatsiz",
    noDue: "Muddatsiz",
    changeStatus: "Holat: {{status}}. O‘zgartirish",
    changeAssignees: "Ijrochilarni o‘zgartirish",
    changeDue: "Muddatni o‘zgartirish",
    changeTester: "Testerni o‘zgartirish",
    searchPeople: "Odamni topish",
    searchTags: "Teg topish yoki yaratish",
    createTag: "«{{name}}» yaratish",
    noTags: "Hozircha teg yo‘q",
    newTag: "Yangi teg",
    tagName: "Teg nomi",
    addTag: "Teg qo‘shish",
    removeTag: "{{name}} tegini olib tashlash",
    tagsAdmin: "Teglar",
    tagsIntro: "Teglar barcha loyihalar uchun umumiy. Vazifani tahrirlay oladigan har kim teg yarata oladi; o‘chirilgan teg barcha vazifalardan olinadi.",
    deleteTagTitle: "«{{name}}» tegi o‘chirilsinmi?",
    deleteTagBody: "U barcha vazifalardan olib tashlanadi. Har bir vazifa tarixida u bo‘lgani saqlanadi.",
    tester: "Tester",
    anyTester: "Loyihadagi istalgan tester",
    created: "Yaratilgan",
    updated: "O‘zgartirilgan",
    key: "Kalit",
    description: "Tavsif",
    addDescription: "Hozircha tavsif yo‘q.",
    writeDescription: "Tavsif yozish",
    markdownMentions: "Kimnidir eslatish uchun @ yozing.",
    mentionSomeone: "Kimnidir eslatish",
    subtasks: "Kichik vazifalar",
    subtasksDone: "Kichik vazifalar: {{total}} tadan {{done}} tasi bajarildi",
    addSubtask: "Kichik vazifa qo‘shish",
    checklists: "Nazorat ro‘yxatlari",
    checklistDone: "Bandlar: {{total}} tadan {{done}} tasi bajarildi",
    addChecklist: "Nazorat ro‘yxati",
    checklistName: "Ro‘yxat nomi",
    noChecklists: "Nazorat ro‘yxati yo‘q.",
    addItem: "Band qo‘shish…",
    deleteChecklist: "Ro‘yxatni o‘chirish",
    deleteChecklistTitle: "«{{name}}» o‘chirilsinmi?",
    deleteChecklistBody: "Ro‘yxat va uning bandlari o‘chiriladi.",
    files: "Fayllar",
    addFile: "Fayl qo‘shish",
    noFiles: "Fayl yo‘q.",
    removeFile: "{{name}} ni o‘chirish",
    links: "Bog‘lanishlar",
    addLink: "Vazifani bog‘lash",
    noLinks: "Bog‘langan vazifa yo‘q.",
    findTask: "Vazifani kalit yoki nom bo‘yicha topish",
    rel: { blocked_by: "To‘sib turadi", blocks: "To‘sadi", relates_to: "Bog‘liq" },
    blocksLabel: "To‘sadi",
    blockedByLabel: "To‘sib turgan",
    relatesTo: "Bog‘liq",
    blockedBy: "{{count}} ta ochiq vazifa to‘sib turibdi",
    blockedNotice: "{{count}} ta ochiq vazifa to‘sib turibdi:",
    comments: "{{count}} ta izoh",
    fields: "Maydonlar",
    testing: "Sinov",
    copyLink: "Havolani nusxalash",
    linkCopied: "Havola nusxalandi",
    changeParent: "Asosiy vazifani o‘zgartirish",
    parentTitle: "{{key}} uchun asosiy vazifa",
    currentParent: "Asosiy vazifa",
    makeTopLevel: "Yuqori darajaga chiqarish",
    moveProject: "Boshqa loyihaga ko‘chirish",
    moveTitle: "{{key}} ni ko‘chirish",
    moveHint: "Yangi loyihada vazifa yangi kalit oladi. Test keyslari, raundlar va izohlar birga ko‘chadi; maxsus maydon qiymatlari ko‘chmaydi.",
    move: "Ko‘chirish",
    moved: "Ko‘chirildi: endi {{key}}",
    firstStatus: "Loyihaning birinchi holati",
    deleteTask: "Vazifani o‘chirish",
    deleteTitle: "{{key}} o‘chirilsinmi?",
    deleteBody: "Vazifa ro‘yxatlardan yo‘qoladi va kaliti ishlamay qoladi. Tarix saqlanadi.",
    deleteBodySubtasks: "Vazifa va uning {{count}} ta kichik vazifasi ro‘yxatlardan yo‘qoladi. Tarix saqlanadi.",
    deleted: "{{key}} o‘chirildi",
    createAnother: "Yana yaratish",
    prevMonth: "Oldingi oy",
    nextMonth: "Keyingi oy",
    nMore: "yana {{count}} ta",
    allDated: "Barcha vazifalarning muddati bor.",
    dragToDate: "Muddat belgilash uchun vazifani kunga sudrab qo‘ying.",
  },
  thread: {
    nChanges: "{{count}} ta o‘zgartirish",
    nChangesBy: "{{actor}} {{count}} ta o‘zgartirish kiritdi",
    collapseChanges: "Yig‘ish",
    hidePanel: "Izohlarni yashirish",
    title: "Izohlar",
    showChanges: "O‘zgarishlar",
    empty: "Hozircha izoh yo‘q. Muhokamani boshlang.",
    older: "Avvalgilarini ko‘rsatish",
    new: "Yangi",
    system: "Mixla",
    none: "yo‘q",
    noDate: "sanasiz",
    deleted: "Izoh o‘chirildi",
    edited: "tahrirlangan",
    editComment: "Izohni tahrirlash",
    delete: "O‘chirish",
    deleteTitle: "Izoh o‘chirilsinmi?",
    deleteBody: "Hamma izoh o‘chirilganini ko‘radi. Uning fayllarini endi ochib bo‘lmaydi.",
    hide: "Men uchun yashirish",
    placeholder: "Izoh yozing… @ — eslatish",
    hint: "⌘/Ctrl+Enter — yuborish · fayllarni qo‘ying yoki sudrab tashlang",
    attach: "Fayl biriktirish",
    send: "Yuborish",
    tooLarge: "{{name}} 100 MB dan katta",
    readOnly: "Kuzatuvchilar izohlarni o‘qiy oladi, lekin yoza olmaydi.",
    event: {
      changed: "{{actor}} vazifani o‘zgartirdi",
      created: "{{actor}} vazifani yaratdi",
      status_changed: "{{actor}} «{{from}}» dan «{{to}}» ga o‘tkazdi",
      due_changed: "{{actor}} muddatni o‘zgartirdi: {{from}} → {{to}}",
      priority_changed: "{{actor}} muhimlikni o‘zgartirdi: {{from}} → {{to}}",
      title_changed: "{{actor}} nomini o‘zgartirdi («{{from}}» edi)",
      assignee_added: "{{actor}} {{user}} ni biriktirdi",
      assignee_removed: "{{actor}} {{user}} ni olib tashladi",
      tester_changed: "{{actor}} testerni o‘zgartirdi: {{from}} → {{to}}",
      parent_changed: "{{actor}} asosiy vazifani o‘zgartirdi: {{from}} → {{to}}",
      epic_changed: "{{actor}} epikni o‘zgartirdi: {{from}} → {{to}}",
      release_changed: "{{actor}} relizni o‘zgartirdi: {{from}} → {{to}}",
      release_added: "{{actor}} buni {{to}} ga qo‘shdi",
      release_removed: "{{actor}} buni {{from}} dan olib tashladi",
      tag_added: "{{actor}} {{tag}} tegini qo‘shdi",
      tag_removed: "{{actor}} {{tag}} tegini olib tashladi",
      attachment_added: "{{actor}} {{file}} ni biriktirdi",
      attachment_removed: "{{actor}} {{file}} ni o‘chirdi",
      moved_out: "{{actor}} boshqa loyihaga ko‘chirdi: {{from_key}} → {{to_key}}",
      moved_in: "{{actor}} shu yerga ko‘chirdi: {{from_key}} → {{to_key}}",
      deleted: "{{actor}} vazifani o‘chirdi",
    },
  },
  testingBoard: {
    nav: "Test",
    title: "Test doskasi",
    intro: "Vazifalar test bosqichlari bo‘yicha. Raundni boshlash uchun kartani «Testga»dan «Testda»ga suring yoki «Boshlash»ni bosing.",
    project: "Loyiha",
    allProjects: "Barcha loyihalar",
    nothing: "Hozircha test qiladigan narsa yo‘q. Dasturchi vazifani test ustuniga o‘tkazganda u shu yerda paydo bo‘ladi.",
    columns: { to_test: "Testga", testing: "Testda", waiting: "Dasturchida", passed: "Sprintda o‘tdi" },
    empty: {
      to_test: "Test kutayotgan narsa yo‘q.",
      testing: "Faol raund yo‘q.",
      waiting: "Dasturchilarga hech narsa qaytmagan.",
      passed: "Bu sprintda hali hech narsa o‘tmagan.",
    },
    passedMore: "Oxirgi {{count}} tasi ko‘rsatilmoqda.",
    cases_one: "{{count}} ta keys",
    cases_few: "{{count}} ta keys",
    cases: "{{count}} ta keys",
    start: "Raundni boshlash",
    startTitle: "{{key}} ni test qilish",
    noCases: "Bu vazifada hali test keyslari yo‘q.",
    writeCases: "Ularni vazifada yozing",
    nothingToRetest: "Oxirgi raunddan beri hech narsa o‘zgarmagan yoki yiqilmagan: barcha keyslarni tanlang.",
  },
  workSettings: {
    testingFlow: "Test ustuni",
    testingFlowIntro: "Vazifani bu statusga o‘tkazish testerlardan test (yoki qayta test) so‘raydi. Test boshlanmasdan undan chiqarilsa, so‘rov bekor qilinadi. Barcha keyslar o‘tgan raund vazifani o‘zi keyingi statusga o‘tkazadi; muvaffaqiyatsiz raunddan keyin u joyida qoladi.",
    testingStatus: "Test statusi",
    testingNone: "Yo‘q — statuslar testga tegmaydi",
    onPass: "Raund o‘tganda, o‘tkazish",
    onPassNext: "Keyingi status ({{name}})",
    onPassStay: "Qoldirish (keyingi status yo‘q)",
    testingSaved: "Test ustuni saqlandi",
    wip: "WIP",
    wipHint: "Doska ustunida vazifalar shundan ko‘p bo‘lsa ogohlantiradi. Ko‘chirish bloklanmaydi.",
    wipFor: "{{name}} uchun WIP chegarasi",
    colorFor: "{{name}} rangi",
    colorDefault: "Toifa rangi",
    colors: { gray: "Kulrang", blue: "Ko‘k", indigo: "Indigo", purple: "Binafsha", pink: "Pushti", red: "Qizil", orange: "To‘q sariq", amber: "Sariq", green: "Yashil", teal: "Moviy-yashil" },
    overLimit: "chegaradan ko‘p",
    wipWarning: "{{name}} da WIP chegarasidan ({{limit}}) ko‘p vazifa bor",
    statuses: "Vazifa holatlari",
    statusesIntro: "Vazifa bosib o‘tadigan bosqichlar, tartib bilan. Toifa nima ochiq yoki tugallangan hisoblanishini belgilaydi; loyihada doim kamida bitta «Bajarildi» holati bo‘ladi.",
    newStatus: "Yangi holat",
    category: "Toifa",
    nTasks: "{{count}} ta vazifa",
    deleteStatus: "«{{name}}» holati o‘chirilsinmi?",
    deleteStatusBody: "Uni hech qaysi vazifa ishlatmaydi.",
    moveTasks: "Bu holatda {{count}} ta vazifa bor. Ularni ko‘chirish:",
    moveTo: "Vazifalarni ko‘chirish",
    fields: "Maxsus maydonlar",
    fieldsIntro: "Loyiha vazifalarining qo‘shimcha xususiyatlari. Ular vazifada, jadvalda va filtrlarda ko‘rinadi.",
    addField: "Maydon qo‘shish",
    editField: "Maydonni tahrirlash",
    fieldName: "Nomi",
    fieldType: "Turi",
    typeFixed: "Maydon turini o‘zgartirib bo‘lmaydi.",
    type: { text: "Matn", number: "Son", date: "Sana", checkbox: "Belgi", single_select: "Ro‘yxatdan tanlash", user: "Odam" },
    options: "Variantlar",
    addOption: "Variant qo‘shish",
    color: "Rang",
    optionRemoveHint: "O‘chirilgan variant uni tanlagan vazifalardan tozalanadi.",
    deleteField: "«{{name}}» maydoni o‘chirilsinmi?",
    deleteFieldBody: "Maydon va uning barcha vazifalardagi qiymatlari o‘chiriladi.",
  },
};

export default workUz;
